import React, { useContext } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import PostDeleteModal from "./PostDeleteModal";
import PostContext from "../../context/post/postContext";
import PostTags from "./PostTags";

import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { grey, yellow } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarIcon from "@material-ui/icons/Star";


const useStyles = makeStyles((theme) => ({
  root: {
    // minWidth: 360,
    direction: "row",
    spacing: 10,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: grey[500],
  },
}));

const PostItem = ({ post }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const postContext = useContext(PostContext);
  const { favoritePost } = postContext;

  const {
    id,
    title,
    content,
    description,
    cover_photo,
    created_at,
    owner_first_name,
    owner_last_name,
    is_favorite,
    avatar,
    tags,
  } = post;

  const onFavorite = () => {
    favoritePost(id, !is_favorite);
  };

  var time = new Date(created_at * 1000);
  var options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  var formatted_time = time.toLocaleDateString("en-US", options);

  return (
    <Grid xs={12}>
      <Card className={classes.root} elevation={3}>
        <CardHeader
          avatar={
            avatar ? (
              <Avatar
                aria-label="recipe"
                className={classes.avatar}
                src={avatar.image_link}
              />
            ) : (
              <Avatar aria-label="recipe" className={classes.avatar}>
                {owner_first_name.charAt(0)}
                {owner_last_name.charAt(0)}
              </Avatar>
            )
          }
          action={<PostDeleteModal id={id} />}
          title={`${owner_first_name} ${owner_last_name}`}
          subheader={formatted_time}
        />
        {cover_photo && (
          <CardMedia
            image={cover_photo.image_link}
            title={cover_photo.title}
            style={{ height: "400px", width: "300" }}
          />
        )}
        <CardContent>
          {title && (
            <Typography gutterBottom variant="h5" component="h2">
              {title}
            </Typography>
          )}
          <Typography variant="body2" color="textSecondary" component="p">
            {description}
          </Typography>
        </CardContent>
        <PostTags tags={tags} />
        <CardActions disableSpacing>
          <IconButton aria-label="add to favorites" onClick={onFavorite}>
            {is_favorite ? (
              <StarIcon style={{ color: yellow[600] }} />
            ) : (
              <StarBorderIcon style={{ color: yellow[600] }} />
            )}
          </IconButton>
          {content && (
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          )}
        </CardActions>
        {content && (
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <Typography paragraph>{content}</Typography>
            </CardContent>
          </Collapse>
        )}
      </Card>
    </Grid>
  );
};

PostItem.propTypes = {
  post: PropTypes.object.isRequired,
};

export default PostItem;
